import { render } from "./NoticeBoard.vue?vue&type=template&id=4e3ab6cc"
import script from "./NoticeBoard.vue?vue&type=script&lang=js"
export * from "./NoticeBoard.vue?vue&type=script&lang=js"

import "./NoticeBoard.vue?vue&type=style&index=0&id=4e3ab6cc&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__